import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-program',
  templateUrl: './citi-shop-program.component.html',
  styleUrls: ['./citi-shop-program.component.scss'],
  standalone: false
})
export class CitiShopProgramComponent implements OnInit {
  programSection:any;
  tileArray:any;
  @Input() contentProgram: any = '{}';
  @Input() userEnrolled: boolean;
  @Output() ctabuttonClicked = new EventEmitter<boolean>();

  constructor(public csp: CitiShopPropsService){}

  ngOnInit(): void {
    this.programSection = this.contentProgram;
    this.tileArray = this.programSection.tiles;
  }

  buttonClicked(event) {
    this.ctabuttonClicked.emit(event);
  }

}
